<template>
<div class="invite">
  <top-nav ref="TopNav"></top-nav>
  <van-nav-bar title="邀请好友" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
    <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
  </van-nav-bar>
  <div class="van-content">
    <img src="/static/images/invitetopimg.png" class="invitetopimg" @click="clearPopup()"/>
    <div class="topbox">
      <img src="/static/images/invitebanner1.png" />
      <div class="inviteqrbox">
        <img v-lazy="datas.img_url" class="urlqr"/>
      </div>
      <div class="btnbox">
        <!--<button class="invitebtn" @click="downImg()"></button>-->
        <button class="invitebtn"><a :href="datas.img_url" download="BLHinvite.png" style="display:inline-block;width: 100%;color: #fff">长按二维码保存图片</a></button>
      </div>
    </div>
    <img src="/static/images/invitebanner4.png" class="invitebanner3"/>
    <van-popup v-model="show">
      <div v-if="show" class="popupbox">
        <van-icon name="close" class="clearbtn" @click="clearPopup()"/>
        <div class="popuptopimg">活动规则</div>
        <div class="textbox">
          <p>活动时间：长期有效</p>
          <p>活动规则：</p>
          <ol>
            <li>在二维码有效期内分享专属图片，邀请好友注册成功后即可得积分；</li>
            <li>此二维码在有效期内可同时邀请多位好友参与；</li>
            <li>未注册的好友邀请后才可获得积分。</li>
            <li>本活动最终解释权归{{ configData.sitename }}所有</li>
          </ol>
          <!--<p style="font-size: 1.2rem;color: red">本活动最终解释权归所有</p>-->
        </div>
      </div>
    </van-popup>
  </div>
</div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "invite",
    components: {
      TopNav
    },
    props:['userConfig','configData'],
    data () {
      return {
        datas:'',
        show:false,
      }
    },
    methods:{
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        var url = window.location.host
        if(this.configData.logintype == 1||this.configData.logintype == 2){
          this.$api.post('WebApi/Member/Share/index', {token:isUser,jump:'http://'+url}, res => {
            this.datas = res.data.data
          })
        }else if(this.configData.logintype == 3){
          this.$api.post('WebApi/Member/Share/index', {token:isUser,jump:'http://'+url+'/register'}, res => {
            this.datas = res.data.data
          })
        }
      },
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      clearPopup() {
        this.show = !this.show
      }
    },
    mounted () {
      this.getDatas()
    }
  }
</script>

<style lang="less" scoped>
.invite{
  .van-content{
    padding-bottom: 0;
    .invitetopimg{
      position: absolute;
      top: 60px;
      left: 0px;
      width: 65px;
    }
    .van-popup{
      width: 80%;
      border-radius: 15px;
      padding: 30px 20px 20px;
      box-sizing: border-box;
    }
    .popupbox{
      .clearbtn{
        font-size: 2rem!important;
        text-align: center;
        color: #fff!important;
        position: absolute;
        right: 0;
        top: 0;
        margin-top: -50px;
      }
      .popuptopimg{
        display: inline-block;
        width: 200px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        font-size: 18px;
        text-align: center;
        background-image: url("/static/images/popuptopimg.png");
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        margin-top: -25px;
        left: 50%;
        margin-left: -100px;
      }
      .textbox{
        ol{
          list-style: decimal;
          padding: 0 16px;
        }
        p,li{
          font-size: 16px;
          line-height: 26px;
        }

      }
    }
    .topbox{
      background: linear-gradient(#ff927c,#f54d4e);
    }
    .inviteqrbox{
      padding: 0 5%;
      position: relative;
      text-align: center;
      .inviteqr{
        position: absolute;
        left: 0;
        top: 0;
        width: 50%;
        margin-top: 26.5%;
        margin-left: 25%;
      }
    }
    .btnbox{
      text-align: center;
      padding: 10px 20% 60px;
      .invitebtn{
        background-color:transparent;
        color: #fff;
        font-size: 1.8rem;
        border: none;
        background: #FEB81C;
        background-size: 100% 100%;
        border-radius:25px ;
        width: 100%;
        height: 40px;
      }
    }
    .invitebanner3{
      margin-top: -15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/invite.vue